import React from 'react';
import { serviceAreas } from '../data/content';
import SafeIcon from '../common/SafeIcon';
import Button from '../components/ui/Button';

export default function ServiceAreas() {
  return (
    <div className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Areas We Serve</h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            BlueFlow Plumbing provides fast, reliable service across the Greater Montreal Area. We dispatch from multiple locations to ensure rapid response times.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
            <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
              <SafeIcon name="Map" className="text-primary" /> Coverage Area
            </h2>
            <div className="grid grid-cols-2 gap-4">
              {serviceAreas.map(area => (
                <div key={area} className="flex items-center gap-2 p-3 bg-slate-50 rounded-lg border border-slate-100">
                  <SafeIcon name="MapPin" className="text-secondary shrink-0" />
                  <span className="font-medium text-slate-700">{area}</span>
                </div>
              ))}
            </div>
            <div className="mt-8 p-4 bg-blue-50 text-blue-900 rounded-lg text-sm">
              <strong className="block mb-1">Don't see your city?</strong>
              Call us anyway. We frequently service surrounding municipalities within a 50km radius of downtown Montreal.
            </div>
          </div>

          <div className="relative h-[500px] bg-slate-200 rounded-2xl overflow-hidden shadow-inner border border-slate-300 flex items-center justify-center">
             {/* Map Placeholder */}
             <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-40 mix-blend-overlay"></div>
             <div className="relative z-10 text-center p-8 bg-white/90 backdrop-blur-sm rounded-xl shadow-lg max-w-sm m-4">
                <SafeIcon name="Navigation" className="text-4xl text-primary mx-auto mb-4" />
                <h3 className="text-xl font-bold mb-2">Montreal Base</h3>
                <p className="text-slate-600 mb-4">Average emergency response time: <strong>45-60 minutes</strong></p>
                <Button to="/request-service" variant="primary" className="w-full justify-center">Book Service Now</Button>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
}